import React, { useEffect, useState } from 'react'
import Spining from '../UI/Spining/Spining'
import DatePicker from 'react-datepicker';
import AdvanceDataTable from '../UI/Table/AdvanceDataTable';
import AdminLayout from '../UI/Layout/AdminLayout';
import Title from '../UI/Text/Title';
import Axios from '../../axios/Axios';
import Select from "react-select";
import { HOST_URL, NODE_HOST_URL } from '../Dashboard/api/Api';
import { userloginDetails } from '../Utils/AdminAuth';
import { EMPLOYEE_CAMPAIGN_DATA } from '../UI/Table/ColumnConst';

const AdminApiReport = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;
    const username = lStorage.user.username;

    const [isLoading, setIsLoading] = useState(false);
    const [dateFilter, setDateFilter] = useState('today');
    const [fromdate, setFromdate] = useState(null);
    const [todate, setTodate] = useState(null);
    const [channel, setChannel] = useState('sms')
    const [allUsers, setAllUsers] = useState('')
    const [selecteduser, setSelectedusers] = useState("");
    const [campaignData, setCampaignData] = useState([]);
    const [totalCost, setTotalCost] = useState(null)
    const [voiceData, setVoiceData] = useState([]);
    const [smsData, setSmsData] = useState([])
    const [emailData, setEmailData] = useState([])
    const [searchData, setSearchData] = useState([]);
    const [searchUser, setSearchUser] = useState([]);
    const [totalData, setTotalData] = useState({
        totalChannelData: 0,
        Delivered: 0,
        failed: 0,
        submitted: 0,
        success: 0,
        sent: 0,
        opened: 0,
        bounced: 0,
        clicked: 0,
        read: 0
    })

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "13px",
        }),
    };


    useEffect(() => {
        const today = new Date();
        if (dateFilter === 'today') {
            setFromdate(today);
            setTodate(today);
        } else {
            setFromdate(null);
            setTodate(null);
        }
    }, [dateFilter]);

    const isOldDate = dateFilter === 'old';

    const today = new Date();
    const todayWithoutTime = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    const isDisabledDate = (date) => {
        const selected = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        return selected >= todayWithoutTime; // disables today and future dates
    };

    useEffect(() => {
        allUserList();
        CampaignReports();
    }, []);

    const userHandler = (e) => {
        setSelectedusers(e.value);
    };

    const currentDate = (currentDate) => {
        const year = currentDate?.getFullYear();
        const month = String(currentDate?.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate?.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const handleChannelChange = (e) => {
        setChannel(e.target.value)
        setSearchData([]);
    }

    const allUserList = async () => {
        const parentParams = {
            user_id: userId,
            method: "retrieve",
            type: adminType,
            token: userToken
        }
        try {
            let { data } = await Axios.post(`${HOST_URL}/employee_user_list.php`, parentParams)
            if (data.success) {
                let filterData = data.data.map((x) => {
                    return ({ label: x.username, value: x.username })
                })
                setAllUsers(filterData)
                setSearchUser(data.data)
                // console.log(data.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const CampaignReports = async () => {
        // let filterData = searchUser.find(x => x.id == selecteduser)
        setIsLoading(true);
        let paramData = {
            user_id: userId,
            token: userToken,
            username: username,
            method: "admin_api_report",
            fromdate: currentDate(fromdate),
            todate: currentDate(todate),
            channel: channel,
            filter_type: dateFilter
        }
        try {
            let { data } = await Axios.post(`${NODE_HOST_URL}/admin/adminApiReport`, paramData)
            if (data.success) {
                let Delivered = 0
                let failed = 0
                let submitted = 0
                let success = 0
                let sent = 0
                let opened = 0
                let bounced = 0
                let clicked = 0
                let read = 0
                let totalChannelData = 0

                if (dateFilter === "today") {
                    if (channel === "sms") {
                        data.mergedSmsResults.forEach((x) => {
                            Delivered += parseInt(x.Delivered);
                            failed += parseInt(x.Failed)
                            submitted += parseInt(x.Submitted)
                        })
                        totalChannelData = (Delivered || 0) + (failed || 0) + (submitted || 0);
                        setTotalData({
                            totalChannelData: totalChannelData,
                            Delivered: Delivered,
                            failed: failed,
                            submitted: submitted,
                        })
                        setSearchData(data.mergedSmsResults)
                    }
                    else {
                        data.data.forEach((x) => {
                            Delivered += parseInt(x.Delivered);
                            failed += parseInt(x.Failed)
                            submitted += parseInt(x.Submitted)
                            success += parseInt(x.Success)
                            sent += parseInt(x.Sent)
                            opened += parseInt(x.Opened)
                            bounced += parseInt(x.Bounce)
                            clicked += parseInt(x.Clicked)
                            read += parseInt(x.Read)
                        })
                        totalChannelData = (Delivered || 0) + (failed || 0) + (submitted || 0) + (success || 0) + (sent || 0) + (opened || 0) + (bounced || 0) + (clicked || 0) + (read || 0);
                        setTotalData({
                            totalChannelData: totalChannelData,
                            Delivered: Delivered,
                            failed: failed,
                            submitted: submitted,
                            success: success,
                            sent: sent,
                            opened: opened,
                            bounced: bounced,
                            clicked: clicked,
                            read: read
                        })
                        setSearchData(data.data)
                    }
                }
                else {
                    data.data.map((items) =>
                        items?.children?.forEach((x) => {
                            Delivered += parseInt(x.Delivered);
                            failed += parseInt(x.Failed)
                            submitted += parseInt(x.Submitted)
                            success += parseInt(x.Success)
                            sent += parseInt(x.Sent)
                            opened += parseInt(x.Opened)
                            bounced += parseInt(x.Bounce)
                            clicked += parseInt(x.Clicked)
                            read += parseInt(x.Read)
                        }))
                    totalChannelData = (Delivered || 0) + (failed || 0) + (submitted || 0) + (success || 0) + (sent || 0) + (opened || 0) + (bounced || 0) + (clicked || 0) + (read || 0);
                    setTotalData({
                        totalChannelData: totalChannelData,
                        Delivered: Delivered,
                        failed: failed,
                        submitted: submitted,
                        success: success,
                        sent: sent,
                        opened: opened,
                        bounced: bounced,
                        clicked: clicked,
                        read: read
                    })
                    setSearchData(data.data)
                }

            }
        } catch (error) {
            console.log(error)
        }
        setIsLoading(false);
    }

    const handleDateFilterChange = (e) => {
        setDateFilter(e.target.value)
        setSearchData([])
    }


    const headerStyle = {
        backgroundColor: '#3F3966',
        color: 'white',
        padding: '10px',
        fontSize: "13px"
    };

    return (
        <div>
            <AdminLayout>
                {/* <Title isButton={false}> API Report </Title> */}

                {(channel !== '' && searchData.length > 0) &&
                    <div className="row">
                        <div className="col-xl-12 col-xxl-5 d-flex">
                            <div className="w-100">
                                <div className="row">
                                    <div className={channel === "sms" ? "col-sm-4" : channel === "voice" ? "col-sm-3" : "col-sm-2"}>
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Total Data</h5>
                                                <h6 className="mt-0 mb-0">{totalData.totalChannelData || 0}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    {(channel === "sms" || channel === "email" || channel === "wp" || channel === "rcs") &&
                                        <div className={channel === "sms" ? "col-sm-4" : "col-sm-2"}>
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0">Delivered</h5>
                                                    <h6 className="mt-0 mb-0">{totalData.Delivered || 0}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {(channel === "sms" || channel === "voice" || channel === "wp" || channel === "rcs") &&
                                        <div className={channel === "sms" ? "col-sm-4" : channel === "voice" ? "col-sm-3" : "col-sm-2"}>
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0">Failed</h5>
                                                    <h6 className="mt-0 mb-0">{totalData.failed || 0}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {(channel === "wp" || channel === 'email' || channel === "rcs") && <div className="col-sm-2">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Sent</h5>
                                                <h6 className="mt-0 mb-0">{totalData.sent || 0}</h6>
                                            </div>
                                        </div>
                                    </div>}
                                    {(channel === "wp" || channel === "rcs") &&
                                        <div className="col-sm-2">
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0"><span>Read</span></h5>
                                                    <h6 className="mt-0 mb-0">{totalData.read || 0}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {(channel === "voice" || channel === "email" || channel === "wp") &&
                                        <div className={channel === "voice" ? "col-sm-3" : "col-sm-2"}>
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0"><span>Submitted</span></h5>
                                                    <h6 className="mt-0 mb-0">{totalData.submitted || 0}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {channel === 'voice' &&
                                        <div className={channel === "voice" ? "col-sm-3" : "col-sm-2"}>
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0"><span>Success</span></h5>
                                                    <h6 className="mt-0 mb-0">{totalData.success || 0}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {channel === 'email' &&
                                        <>
                                            <div className="col-sm-2">
                                                <div className="card">
                                                    <div className="card-body p-2">
                                                        <h5 className="card-title mb-0"><span>Opened</span></h5>
                                                        <h6 className="mt-0 mb-0">{totalData.opened || 0}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="card">
                                                    <div className="card-body p-2">
                                                        <h5 className="card-title mb-0"><span>Bounced</span></h5>
                                                        <h6 className="mt-0 mb-0">{totalData.bounced || 0}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="card">
                                                    <div className="card-body p-2">
                                                        <h5 className="card-title mb-0"><span>Clicked</span></h5>
                                                        <h6 className="mt-0 mb-0">{totalData.clicked || 0}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                    {/* <div className="col-sm-2">
                                        <div className="card">
                                            <div className="card-body p-2 ">
                                                <h5 className="card-title mb-0">Total Cost</h5>
                                                <h6 className="mt-0 mb-0">
                                                    {parseFloat(totalCost).toFixed(2) || 0}
                                                </h6>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>}

                <div className="row">
                    <div className="">
                        <div className="card">
                            {/* {alert.status === true ? (
                                <div className={alert.bgColor} role="alert">
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                    <div className="">{alert.errorMessage}</div>
                                </div>
                            ) : null} */}

                            {isLoading && <Spining />}

                            <div className="card-body">
                                <div className="filter-option" >
                                    <div className='row mb-2'>
                                        <div className='col-6'>
                                            <h6 className="card-subtitle text-muted">
                                                <b>API Report{" "}</b>
                                            </h6>
                                        </div>
                                        <div className='col-6'>
                                            <button type="button" className="btn btn-info float-right" onClick={CampaignReports}>Search</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className='col-3'>
                                            <label>Select Date</label>
                                            <select value={dateFilter} className='form-control' onChange={handleDateFilterChange}>
                                                <option value="today">Today Date</option>
                                                <option value="old">Old Date</option>
                                            </select>
                                        </div>

                                        <div className="col-md-3">
                                            <label>Select Channel</label>
                                            <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                                                <div className="input-group mb-2 mr-sm-2 ">
                                                    <select className='form-control' value={channel} onChange={handleChannelChange}>
                                                        <option value="">Select Channel</option>
                                                        <option value="sms">SMS</option>
                                                        <option value="voice">Voice</option>
                                                        <option value="email">Email</option>
                                                        <option value="wp">Whatsapp</option>
                                                        <option value="rcs">RCS</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        {/* {dateFilter === "old" &&
                                            <div className="col-md-3">
                                                <label>Select User</label>
                                                <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                                                    <div className="input-group mb-2 mr-sm-2 ">
                                                        <Select
                                                            onChange={userHandler}
                                                            options={allUsers}
                                                            isSearchable={true}
                                                            placeholder="All Users"
                                                            styles={customStyles}
                                                        />
                                                    </div>
                                                </div>
                                            </div>} */}

                                        <div className="col-md-3">
                                            <label>From Date</label>
                                            <div className="input-group mb-2 mr-sm-2 table2">
                                                {/* <div className="input-group-text">
                          <FontAwesomeIcon icon={faCalendarAlt} />
                        </div> */}

                                                <DatePicker
                                                    className="form-control btn-block"
                                                    selected={fromdate}
                                                    onChange={(date) => setFromdate(date)}
                                                    filterDate={isOldDate ? (date) => !isDisabledDate(date) : undefined}
                                                    placeholderText="Select from date"
                                                    disabled={dateFilter === 'today'}
                                                    isClearable={isOldDate}
                                                />

                                                {/* <ReactDatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="dd/MM/yyyy"
                                                    value={fromdate}
                                                    onChange={(date) => setFromdate(date)}
                                                    maxDate={isOldDate ? today : null}
                                                    disabled={dateFilter === 'today'}
                                                    selected={fromdate}
                                                    placeholderText="From Date"
                                                /> */}

                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <label>To Date</label>
                                            <div className="input-group mb-2 mr-sm-2 table3">
                                                {/* <div className="input-group-text">
                          <FontAwesomeIcon icon={faCalendarAlt} />
                        </div> */}
                                                <DatePicker
                                                    className="form-control btn-block"
                                                    selected={todate}
                                                    onChange={(date) => {
                                                        if (isOldDate && isDisabledDate(date)) return;
                                                        setTodate(date);
                                                    }}
                                                    filterDate={isOldDate ? (date) => !isDisabledDate(date) : undefined}
                                                    placeholderText="Select to date"
                                                    disabled={dateFilter === 'today'}
                                                    isClearable={isOldDate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    {/* Uncomment and configure AdvanceDataTable if needed
    <AdvanceDataTable
        tableName={""}
        tableCell={EMPLOYEE_CAMPAIGN_DATA}
        tableData={campaignData}
        isLoading={isLoading}
        filterstatus={false}
        pagination={true}
    /> 
    */}

                                    <div className='card mt-4'>
                                        {searchData.length > 0 && dateFilter === "today" ? <h6 className='m-3'>Today Active Users : <span style={{ color: "green" }}>{searchData.length}</span></h6> : null}
                                        {searchData.length > 0 &&
                                            <table style={{ borderCollapse: 'collapse', width: '100%' }}>

                                                <thead>
                                                    <tr>
                                                        <th style={headerStyle}><span>Parent Name</span></th>
                                                        <th style={headerStyle}><span>Child Name</span></th>
                                                        <th style={headerStyle}>Total</th>
                                                        {channel === "sms" || channel === "email" || channel === "wp" || channel === "rcs" ? <th style={headerStyle}>Delivered</th> : null}
                                                        {channel === "sms" || channel === "voice" || channel === "wp" || channel === "rcs" ? <th style={headerStyle}>Failed</th> : null}
                                                        {channel === "voice" && <th style={headerStyle}>Success</th>}
                                                        {channel === "email" || channel === "wp" || channel === "rcs" ? <th style={headerStyle}>Sent</th> : null}
                                                        {(channel === "wp" || channel === "rcs") && <th style={headerStyle}>Read</th>}
                                                        {(channel === "wp" || channel === "email" || channel === "voice") && <th style={headerStyle}>Submitted</th>}
                                                        {channel === "email" &&
                                                            <>
                                                                <th style={headerStyle}>Opened</th>
                                                                <th style={headerStyle}>Bounced</th>
                                                                {dateFilter === "old" && <th style={headerStyle}>Clicked</th>}
                                                            </>}
                                                    </tr>
                                                </thead>
                                                {dateFilter === "today" ?
                                                    <>
                                                        {searchData?.map((x) =>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.parent_username}</td>
                                                                    <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.child_username}</td>
                                                                    {channel === "sms" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{parseInt(x.Delivered + x.Failed)}</td>}
                                                                    {channel === "voice" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{(parseInt(x.User_Busy) + parseInt(x.Ring_Timeout) + parseInt(x.Network_Congestion) + parseInt(x.Success))}</td>}
                                                                    {channel === "email" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{parseInt(x.Delivered) + parseInt(x.Sent) + parseInt(x.Opened) + parseInt(x.Bounce)}</td>}
                                                                    {channel === "wp" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{parseInt(x.Delivered) + parseInt(x.Sent) + parseInt(x.Failed) + parseInt(x.Read)}</td>}
                                                                    {channel === "rcs" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{parseInt(x.delivered) + parseInt(x.sent) + parseInt(x.failed) + parseInt(x.read)}</td>}
                                                                    {channel === "sms" || channel === "email" || channel === "wp" || channel === "rcs" ? <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Delivered || 0}</td> : null}
                                                                    {channel === "sms" || channel === "voice" || channel === "wp" || channel === "rcs" ? <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{channel === "voice" ? parseInt(x.User_Busy) + parseInt(x.Ring_Timeout) + parseInt(x.Network_Congestion) : x.Failed || 0}</td> : null}
                                                                    {channel === "voice" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Success || 0}</td>}
                                                                    {channel === "email" || channel === "wp" || channel === "rcs" ? <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Sent || 0}</td> : null}
                                                                    {(channel === "wp" || channel === "rcs") && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Read || 0}</td>}
                                                                    {(channel === "wp" || channel === "email" || channel === "voice") && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Submitted || 0}</td>}
                                                                    {channel === "email" &&
                                                                        <>
                                                                            <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Opened || 0}</td>
                                                                            <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Bounce || 0}</td>
                                                                            {dateFilter === "old" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Clicked || 0}</td>}
                                                                        </>}
                                                                </tr>
                                                            </tbody>
                                                        )}
                                                    </>
                                                    :
                                                    <>
                                                        {searchData?.map((item) =>
                                                            item.children.map((x) => (
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{item.parent_name}</td>
                                                                        <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.child_name}</td>
                                                                        {channel === "sms" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Delivered + x.Failed}</td>}
                                                                        {channel === "voice" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{ x.Success + x.Failed + x.Submitted}</td>}
                                                                        {channel === "email" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{ x.Delivered + x.Sent + x.Submitted + x.Opened + x.Bounced + x.Clicked}</td>}
                                                                        {channel === "wp" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{ x.Delivered + x.Sent + x.Submitted + x.Failed + x.Read}</td>}
                                                                        {channel === "rcs" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Delivered + x.Sent + x.Failed + x.Read}</td>}
                                                                        {channel === "sms" || channel === "email" || channel === "wp" || channel === "rcs" ? <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Delivered || 0}</td> : null}
                                                                        {channel === "sms" || channel === "voice" || channel === "wp" || channel === "rcs" ? <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Failed || 0}</td> : null}
                                                                        {channel === "voice" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Success || 0}</td>}
                                                                        {channel === "email" || channel === "wp" || channel === "rcs" ? <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Sent || 0}</td> : null}
                                                                        {(channel === "wp" || channel === "rcs") && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Read || 0}</td>}
                                                                        {(channel === "wp" || channel === "email" || channel === "voice") && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Submitted || 0}</td>}
                                                                        {channel === "email" &&
                                                                            <>
                                                                                <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Opened || 0}</td>
                                                                                <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Bounce || 0}</td>
                                                                                {dateFilter === "old" && <td style={{ fontSize: "13px", padding: ".6rem", color: "black" }}>{x.Clicked || 0}</td>}
                                                                            </>}
                                                                    </tr>
                                                                </tbody>
                                                            ))
                                                        )}
                                                    </>}
                                            </table>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminLayout>
        </div>
    )
}

export default AdminApiReport
